import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  margin-top: 1rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--black-200);
`

export const Count = styled.div`
  width: 6rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: space-between;
  color: var(--grey-100);
`

export const ButtonsContainer = styled.div`
  width: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const HelpText = styled.span`
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--grey-100);

  margin-right: 1.2rem;
`

export const Points = styled.p`
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  line-height: 1.3rem;
  margin-left: 0.5rem;
`